/** User self-service (gateway-local; /users/v1/user in cloud via resolvePath). */
export const userEndpoints = {
  me: '/v1/user',
  passwordRecover: '/v1/user/password/recover',
  passwordRecoverConfirm: '/v1/user/password/recover/confirm',
} as const;

/** Admin user management (gateway-cloud /users/v1/admin) — cloud-mode + admin only. */
export const adminEndpoints = {
  users: '/users/v1/admin/users',
  userSearch: (q: string) => `/users/v1/admin/users/search?q=${encodeURIComponent(q)}`,
  user: (id: string) => `/users/v1/admin/users/${id}`,
  invite: '/users/v1/admin/users/invite',
  invitations: '/users/v1/admin/invitations',
  roles: '/users/v1/admin/roles',
  refreshInvitation: (email: string) =>
    `/users/v1/admin/users/${encodeURIComponent(email)}/refresh-invitation`,
  revokeInvitation: (email: string) => `/users/v1/admin/users/${encodeURIComponent(email)}/invitation`,
  resetLink: (id: string) => `/users/v1/admin/users/${id}/reset-link`,
  resetMfa: (id: string) => `/users/v1/admin/users/${id}/mfa`,
  setActive: (id: string) => `/users/v1/admin/users/${id}/active`,
  /** ⚠ The site a non-admin may reach at all. `home_site_id` is the tier gate the SITE
   *  checks on every call (`infra_admission`): no home = refused everywhere, which read
   *  as "permissions are broken" until it could be assigned.
   *
   *  ⚠ R-349 — this is the STANDALONE access grant, for changing the site without
   *  touching the type. It refuses both halves of the contradiction now: a home for
   *  an `hq`/`admin` user, and a clear for a `local` one. To change the TYPE, send
   *  `home_site_id` on `update` instead — the pair has to move in one request. */
  homeSite: (id: string) => `/users/v1/admin/users/${id}/home-site`,
  permissions: '/users/v1/admin/permissions',
  permissionCell: (roleId: string, module: string) =>
    `/users/v1/admin/permissions/${encodeURIComponent(roleId)}/${encodeURIComponent(module)}`,
} as const;

/** Invitation flow (gateway-cloud, no auth). */
export const invitationEndpoints = {
  get: (token: string) => `/users/v1/invitations/${encodeURIComponent(token)}`,
  complete: (token: string) => `/users/v1/invitations/${encodeURIComponent(token)}/complete`,
} as const;
